import axios from 'axios';
import { getErrorMessage, showErrorToast, showSuccessToast } from '../utils/toast';

export const FETCH_TENANT_REQUEST = 'FETCH_TENANT_REQUEST' as const;
export const FETCH_TENANT_SUCCESS = 'FETCH_TENANT_SUCCESS' as const;
export const FETCH_TENANT_FAILURE = 'FETCH_TENANT_FAILURE' as const;

export const FETCH_TENANT_DETAIL_REQUEST = 'FETCH_TENANT_DETAIL_REQUEST' as const;
export const FETCH_TENANT_DETAIL_SUCCESS = 'FETCH_TENANT_DETAIL_SUCCESS' as const;
export const FETCH_TENANT_DETAIL_FAILURE = 'FETCH_TENANT_DETAIL_FAILURE' as const;

export const UPDATE_TENANT_DETAIL_REQUEST = 'UPDATE_TENANT_DETAIL_REQUEST' as const;
export const UPDATE_TENANT_DETAIL_SUCCESS = 'UPDATE_TENANT_DETAIL_SUCCESS' as const;
export const UPDATE_TENANT_DETAIL_FAILURE = 'UPDATE_TENANT_DETAIL_FAILURE' as const;

export const CLEAR_STORE = 'CLEAR_STORE' as const;

export const clearStoreAction = () => ({
  type: CLEAR_STORE,
});

export const fetchTenants = (programId: number | string) => async (dispatch: any) => {
  dispatch({ type: FETCH_TENANT_REQUEST });
  try {
    const token = localStorage.getItem('accessToken');
    const userDetails = JSON.parse(localStorage.getItem('userDetails') ?? '{}');

    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/tenant/${userDetails.roleResourceId}?programId=${programId}`,
      timeout: 10000000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params: {
        limit: 1000,
      },
      method: 'GET',
    });

    dispatch({ type: FETCH_TENANT_SUCCESS, payload: response.data });
  } catch (error: any) {
    const msg = getErrorMessage(error, 'Failed to load outlets');
    dispatch({ type: FETCH_TENANT_FAILURE, error: msg });
    showErrorToast(msg);
  }
};

export const fetchTenant = (tenantId: number | string) => async (dispatch: any) => {
  dispatch({ type: FETCH_TENANT_DETAIL_REQUEST });
  try {
    const token = localStorage.getItem('accessToken');
    const userDetails = JSON.parse(localStorage.getItem('userDetails') ?? '{}');
    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/tenant/${userDetails.roleResourceId}/${tenantId}`,
      timeout: 10000000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'GET',
    });

    dispatch({ type: FETCH_TENANT_DETAIL_SUCCESS, payload: response.data });
  } catch (error: any) {
    const msg = getErrorMessage(error, 'Failed to load outlet details');
    dispatch({ type: FETCH_TENANT_DETAIL_FAILURE, error: msg });
    showErrorToast(msg);
  }
};

export const updateTenant = (
  storeCoordinator: string,
  phone: string,
  address: string,
  wing: string,
  floor: string,
  tenantBrand: string,
  image: File | null,
  logo: File | null,
  tenantId: number | string | undefined,
  latitude: number | null,
  longitude: number | null,
  state: string,
  city: string,
) => async (_dispatch: unknown) => {
  const dispatch = _dispatch as any;
  dispatch({ type: UPDATE_TENANT_DETAIL_REQUEST });
  try {
    const token = localStorage.getItem('accessToken');
    const userDetails = JSON.parse(localStorage.getItem('userDetails') ?? '{}');
    const formData = new FormData();
    formData.append('storeCoordinator', storeCoordinator);
    formData.append('phone', phone);
    formData.append('address', address);
    if (latitude != null) formData.append('latitude', String(latitude));
    if (longitude != null) formData.append('longitude', String(longitude));
    formData.append('state', state);
    formData.append('city', city);
    formData.append('wing', wing);
    formData.append('floor', floor);
    formData.append('tenantBrand', tenantBrand);

    if (image) {
      formData.append('storeImage', image);
    }

    if (logo) {
      formData.append('storeLogo', logo);
    }
    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/tenant/${userDetails.roleResourceId}/${tenantId}`,
      timeout: 10000000,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      method: 'PUT',
      data: formData,
    });

    if (response.status === 200) {
      dispatch({ type: UPDATE_TENANT_DETAIL_SUCCESS, payload: response.data });
      showSuccessToast('Outlet updated successfully');
      return Promise.resolve();
    }
    const msg = 'Failed to update outlet';
    dispatch({ type: UPDATE_TENANT_DETAIL_FAILURE, error: msg });
    showErrorToast(msg);
    return Promise.reject();
  } catch (error: unknown) {
    const msg = getErrorMessage(error, 'Failed to update outlet');
    dispatch({ type: UPDATE_TENANT_DETAIL_FAILURE, error: msg });
    showErrorToast(msg);
    return Promise.reject();
  }
};

